import axios from 'axios';
import store from '@app/plugins/vuex';
import router from '@app/plugins/vue-router';

import { API_URL } from '@shared/helpers/env';
import { ErrorResponse } from '@shared/models/error-response';

function create_instance(opts = {}, full_response = false) {
  const { base_url = API_URL, api_version = 2, resource = '' } = opts;

  const baseUrl = `${base_url}/api/${api_version ? '/v' + api_version : ''}/${resource}`.replace(
    new RegExp(/(^|[^:])\/\//, 'g'),
    '$1/'
  );
  const client = axios.create(
    (opts = {
      baseURL: baseUrl
    })
  );

  client.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  client.interceptors.request.use(
    (config) => {
      if (store && store.getters['core/auth/token']) {
        config.headers.common['Authorization'] = `Bearer ${store.getters['core/auth/token']}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  /**
   * TODO :: По идее можно выпилить кусок с проверку success. Пока закоментировал.
   * После окончательной интеграции проверить и выпилить, если не используется.
   */
  client.interceptors.response.use(
    (response) => {
      if (full_response) return response;

      response = 'data' in response ? response['data'] : response;

      // if (typeof response === 'object' && 'success' in response && response['success'] === false) {
      //   return Promise.reject(new Error(response['error']));
      // }
      return response;
    },
    (err) => {
      const resp = err.response;
      if (resp?.status && resp?.status === 401) {
        store.dispatch('core/auth/logout').then(() => {
          if (!window.location.pathname.includes('auth/login')) {
            router.push({ name: 'auth.login' });
          }
        });
      }

      return Promise.reject(new ErrorResponse(err));
    }
  );

  return client;
}

export { axios, create_instance };
